export interface VideoSourceProps {
  src: string
  type?: string
}

export const VideoSource: React.FC<VideoSourceProps> = ({ src, type }) => (
  <source src={src} type={type} />
)
